const selector = {
  rightColumn: '.js-pdp__right-column',
  rightColumnContent: '.js-pdp__right-column-content',
  rightColumnMargin: '.js-pdp__right-column-margin',
  accordionsPdp: '.js-accordion--product-details'
};

const rightColumnWrapper = document.querySelector(selector.rightColumn);
const rightColumnContent = document.querySelector(selector.rightColumnContent);
const rightColumnMarginElement = document.querySelector(
  selector.rightColumnMargin
);

var lastScrollTop = 0;

const rightColumnScrollBehaviour = () => {
  // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
  const st = window.scrollY || document.documentElement.scrollTop;
  const elHeight = rightColumnContent.offsetHeight;
  const viewportHeight = window.innerHeight;
  const offsetDistance = -(elHeight - viewportHeight);
  const distanceFromTop = -(
    rightColumnWrapper.getBoundingClientRect().top -
    rightColumnContent.getBoundingClientRect().top
  );

  const heightIsLowerThanViewport = offsetDistance >= 0;

  if (heightIsLowerThanViewport) {
    rightColumnContent.style.top = `80px`;
    rightColumnContent.style.removeProperty('bottom');
    rightColumnMarginElement.style.removeProperty('margin-top');
  } else if (st > lastScrollTop) {
    // downscroll code
    rightColumnContent.style.top = `${offsetDistance}px`;
    rightColumnContent.style.removeProperty('bottom');
    rightColumnMarginElement.style.marginTop = `${distanceFromTop}px`;
  } else if (st < lastScrollTop) {
    rightColumnContent.style.bottom = `${offsetDistance - 80}px `; // 80 is the height of the header
    rightColumnContent.style.removeProperty('top');
    rightColumnMarginElement.style.marginTop = `${distanceFromTop}px`;

    // upscroll code
  } // else was horizontal scroll
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
};

const initAccordionsBehaviour = () => {
  const accordionsWrapper = document.querySelector(selector.accordionsPdp);
  if (!accordionsWrapper) return;

  const accordions = accordionsWrapper.querySelectorAll(
    'input[type="checkbox"]'
  );

  accordions.forEach((accordion) => {
    if (accordion.name !== 'promotions') {
      accordion.addEventListener('click', () => {
        accordions.forEach((acc) => {
          if (acc !== accordion && acc.name !== 'promotions') {
            acc.checked = false;
          }
        });
      });
    }
  });
};

const addRightColumnScrollBehaviour = () => {
  window.addEventListener('scroll', rightColumnScrollBehaviour, false);
};

const removeRightColumnScrollBehaviour = () => {
  rightColumnMarginElement.style.removeProperty('margin-top');
  window.removeEventListener('scroll', rightColumnScrollBehaviour, false);
};

export {
  addRightColumnScrollBehaviour,
  removeRightColumnScrollBehaviour,
  initAccordionsBehaviour
};
